import { Banner } from "@src/appV2/redesign/system/ui-components";

export function FileUploaderEmptyState() {
  return (
    <Banner
      intent="disabled"
      illustrationType="document-upload"
      title="No files uploaded yet"
      description="Upload one to get started!"
    />
  );
}
